export var VERSION = '1.0.20';
//# sourceMappingURL=version.js.map